import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef } from "vue"

import { ref, watchEffect, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVModel, useDebounceFn } from '@vueuse/core'
import { findCusNameRelByPage as findCusNameRelByPageFbu } from '@/api/gucangSales/customerCenter'
import { findCusNameRelByPage as findCusNameRelByPageOfbu } from '@/api/overseasSales/customerCenter'

const __default__ = { name: 'ClueAndCustomerSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    value: {},
    label: {},
    record: {},
    disabled: { type: Boolean }
  },
  emits: ['update:value', 'update:label', 'update:record'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const findCusNameRelByPageMethod = {
  cos_fbu: findCusNameRelByPageFbu,
  cos_ofbu: findCusNameRelByPageOfbu
}
const props = __props
const emit = __emit
const modelValue = useVModel(props, 'value', emit)
const modelLabel = useVModel(props, 'label', emit)
const modelRecord = useVModel(props, 'record', emit)

const clueAndCustomerEnum = ref<any[]>([]) // 客户下拉选择框数据
const searchValue = ref<string>() // 搜索框值
const initId = ref<number | string>() // 初始化id
const firstInit = ref(true) // 第一次初始化
const totalPage = ref(0) // 总页数
const queryForm = ref<{
  id?: number | string
  content?: string
  pageNumber: number
  pageSize: number
}>({ pageNumber: 1, pageSize: 100 }) // 分页参数
const getClueAndCustomerList = () => {
  findCusNameRelByPageMethod[props.appId](queryForm.value).then(({ data }: { data: any }) => {
    if (queryForm.value.content) {
      clueAndCustomerEnum.value = []
      delete queryForm.value.content
    }
    // 1、带 id 参数请求时只会返回一条数据
    // 2、当后续返回参数包含第一条数据时,需要删除该条数据,防止数据重复
    const findIndex = data.items.findIndex((item: any) => item.cosId === initId.value)
    if (findIndex !== -1 && !firstInit.value) data.items.splice(findIndex, 1)

    // 1、初始化带 id 参数请求时,如果查询数据为空,则考虑是用户已被假如黑名单
    // 2、此时将详情数据的 id 和 name 暂时赋值给下拉选项,便于展示数据
    if (firstInit.value && !data.items.length && modelValue.value && modelLabel.value) {
      data.items.push({
        disabled: true,
        cosId: modelValue.value,
        customerName: modelLabel.value
      })
    }

    // TODO: bug 临时处理，当只有一个数据时，判断是否重复添加
    if (clueAndCustomerEnum.value.length === 1) {
      const findIndex = data.items.findIndex((item: any) => item.cosId === clueAndCustomerEnum.value[0].cosId)
      if (findIndex !== -1) data.items.splice(findIndex, 1)
    }

    // 分页数据合并
    clueAndCustomerEnum.value = clueAndCustomerEnum.value.concat(data.items || [])
    totalPage.value = data.totalPage
    // 当 disabled 为 false 时,修改 firstInit 状态，否则每次都当作是首次初始化
    if (!props.disabled) firstInit.value = false
  })
}

watch(
  modelValue,
  async (newValue, oldValue) => {
    if (newValue && firstInit.value) {
      // 数据回显首次初始化
      initId.value = newValue
      queryForm.value.id = newValue
      await getClueAndCustomerList()
      delete queryForm.value.id
    }
    // 监听 clear 清空
    if (newValue == null && oldValue) {
      clueAndCustomerEnum.value = []
      queryForm.value.pageNumber = 1
      await getClueAndCustomerList()
    }
  },
  { immediate: true }
)

watchEffect(() => {
  if (modelValue.value && clueAndCustomerEnum.value.length) {
    const find = clueAndCustomerEnum.value.find((item) => item.cosId === modelValue.value)
    modelLabel.value = find?.customerName
    modelRecord.value = find || {}
  }
})

const popupScroll = (e: Event) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target as HTMLDivElement
  if (scrollHeight - scrollTop === clientHeight && queryForm.value.pageNumber < totalPage.value) {
    queryForm.value.pageNumber++
    getClueAndCustomerList()
  }
}
const handleFocus = () => {
  if (searchValue.value != null) return
  if (clueAndCustomerEnum.value.length === 0 || clueAndCustomerEnum.value.length === 1) {
    getClueAndCustomerList()
  }
}
const handleSearch = useDebounceFn((val: string) => {
  searchValue.value = val.trim()
  if (val) {
    queryForm.value.content = val.trim()
  } else {
    clueAndCustomerEnum.value = []
  }
  queryForm.value.pageNumber = 1
  delete queryForm.value.id
  getClueAndCustomerList()
}, 500)

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _unref(modelValue),
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    showSearch: "",
    filterOption: false,
    placeholder: _unref(t)('common.pleaseSelect'),
    disabled: props.disabled,
    allowClear: "",
    onPopupScroll: popupScroll,
    onFocus: handleFocus,
    onSearch: _unref(handleSearch)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clueAndCustomerEnum.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.cosId,
          value: item.cosId,
          disabled: item.disabled
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.customerNumber ? `${item.customerName}(${item.customerNumber})` : item.customerName), 1)
          ]),
          _: 2
        }, 1032, ["value", "disabled"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "onSearch"]))
}
}

})